import { createContext } from 'react';

export const PortalAgentesContext = createContext();
export const PortalAgentesProvider = PortalAgentesContext.Provider;

export const PortalAgentesFormContext = createContext();
export const PortalAgentesFormProvider = PortalAgentesFormContext.Provider;